import { Dispatch, SetStateAction } from "react";
import { FileState, Project, ProjectFile } from "../../proto/api_pb";
import { Inbox, Session } from "talkjs/all";

export interface SingleProjectProps {
    project: Project;
    session: Session | undefined;
    setInbox: Dispatch<SetStateAction<Inbox | undefined>>;
    handleUseEffect: (refresh?: boolean) => Promise<void>
    openFoldersList?: OpenFoldersListType[]
    setOpenFoldersList?: Dispatch<SetStateAction<OpenFoldersListType[]>>
    index?: number;
    isReorderAvailable?: boolean;
    handleDragStart?: (index: number) => void;
    handleDrop?: () => void;
    setDraggedIndex?: (index: number | null) => void;
}

export interface ProjectSearchBarProps {
    queryValue: string;
    setQueryValue: Dispatch<SetStateAction<string>>;
    setPage: Dispatch<SetStateAction<number>>;
    setProjects: Dispatch<SetStateAction<Project[]>>
}

export interface ProjectFileSearchBarProps {
    queryValue: string;
    setQueryValue: Dispatch<SetStateAction<string>>;
}

export const photo =
    "https://img.freepik.com/free-photo/wide-angle-shot-single-tree-growing-clouded-sky-sunset-surrounded-by-grass_181624-22807.jpg?t=st=1719298357~exp=1719301957~hmac=34f196060d6c2b73f48bb315c953fcc5829f4dfe69575d35cd4a142b83a24e8b&w=1060";

export const FileStateReverseMap = Object.keys(FileState).reduce((acc, key) => {
    const value = (FileState as any)[key];
    acc[value] = key;
    return acc;
}, {} as { [key: number]: string });

export interface ProjectFileProps {
    projectFile: ProjectFile;
    session: Session | undefined
    setInbox: Dispatch<SetStateAction<Inbox | undefined>>
    getProjectFiles: () => Promise<void>;
    isFileChecked?: (item: ProjectFile) => boolean;
    handleCheckedFileChange?: (file: ProjectFile, id: string) => void;
    setProjectFiles: Dispatch<SetStateAction<ProjectFile[]>>
    isAddFolderToProject?: boolean;
    allowDownload: boolean | undefined;
    setIsPreviewModalOpen?: Dispatch<SetStateAction<boolean>>
    setSelectedFileToPreview?: Dispatch<SetStateAction<ProjectFile | null>>;
    getStorageUsed?: () => Promise<void>
    shareType?: number;
}

export interface OpenFoldersListType {
    id: string;
    name: string
}